// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'

class DrawerNavigationMainPromo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.item.elements.length <= 2) {
      return
    }

    this.dotCarousel = this.initialiseDotCarousel()
  }

  setupListeners () {
    super.setupListeners()
  }

  initialiseDotCarousel () {
    return new KeenSlider(this.els.slider.element, {
      slides: {
        perView: 2.2,
        spacing: 10,
      },
    })
  }

  /** @param {PointerEvent} event */
  handleDotClick (event) {
    const dotIndex = this.els.dot.elements.indexOf(event.currentTarget)

    this.activeIndex = dotIndex

    this.dotCarousel.moveToIdx(dotIndex)
  }

  /** @returns {number} */
  get activeIndex () {
    return this.els.item.elements.findIndex(
      item => item.getAttribute('aria-current') === 'true',
    )
  }

  set activeIndex (activeIndex) {
    this.els.item.elements.forEach((item, index) => {
      item.setAttribute('aria-current', activeIndex === index)
    })
  }

  get autoplaySpeed () {
    return Number(this.getAttribute('autoplay-speed'))
  }
}

if (!window.customElements.get('drawer-navigation-slider')) {
  window.customElements.define(
    'drawer-navigation-slider',
    DrawerNavigationMainPromo,
  )
}
